import SpecialtiesHero from '../../Specialties/SpecialtiesHero/SpecialtiesHero'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import { useAppContext } from '../../../context/AppState/AppContext';

export default function PhilosophySection() {
  const {jsonTexts, jsonMedia} = useAppContext();
  const {description, title} = jsonTexts.aboutUs.philosophySection;
   const {width} = useWindowDimensions()
   const isMobile = width <= 768

   const image = jsonMedia?.institutional?.philosophyBannerImage
  return (
      < SpecialtiesHero height={isMobile ? 200 : 250}  title={title} right='0px' imageUrl={image} description={description} imageBackgroundColor="var(--color-tertiary)" square />
  )
}
